<script setup lang="ts">
import { createTextStyle } from '@/common/customisation/utils/styleUtils';
import { PUI } from '@pleased-npm/fe-customisation';
import { useHelpBodyTitleCustomisation } from './composables/useHelpBodyCustomisation';
import SelfServiceLink from './components/SelfServiceLink.vue';

const SELF_SERVICE_LINK_SECTIONS = [
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_1,
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_2,
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_3,
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_4,
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_5,
  PUI.HELP_SECTION_KEYS.SELF_SERVICE_LINK_6,
] as const;

const selfServiceLinks = SELF_SERVICE_LINK_SECTIONS.map((sectionKey) => ({ sectionKey }));

const bodyTitleCustomisation = useHelpBodyTitleCustomisation();
const sectionTitleStyle = createTextStyle(bodyTitleCustomisation.textColor);
</script>

<template>
  <div class="self-service-section">
    <h2 v-show="bodyTitleCustomisation.isVisible" class="section-title theme-font-main" :style="sectionTitleStyle">
      {{ bodyTitleCustomisation.textContent.value }}
    </h2>

    <div class="self-service-list">
      <SelfServiceLink v-for="link in selfServiceLinks" :key="link.sectionKey" :section-key="link.sectionKey" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/scss/variable.scss';
@import '@/assets/scss/mixin.scss';

.self-service-section {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  margin: 0;
}

.self-service-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
